/**
 * Minimal generating feedback — muted copy + three animated dots.
 * Styles: ReadingAssistant.css (.ai-generating-status*).
 */
const AiGeneratingStatus = ({ message, className = "" }) => {
  if (!message) return null;

  return (
    <p
      className={["ai-generating-status", className].filter(Boolean).join(" ")}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span>{message}</span>
      <span className="ai-generating-status__dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
    </p>
  );
};

export default AiGeneratingStatus;
